function handleAdditionalItems() {
    const popoverClose = document.querySelectorAll('.js-custom-product .charms-outer-container .popover-close');
    const productForm = document.querySelector('.js-custom-product form[data-product-form]');
    const container = document.querySelector('.js-custom-product .charms-outer-container');
    const inner = container.querySelector('.charms-inner');
    const charmBtn = inner.querySelector('.charm-btn-label');
    const totalQuantity = inner.querySelector('.charm-label span');
    const addedProductsContainer = container.querySelector('.charm-added-products');
    const charmProducts = container.querySelectorAll('.charms-products input');
    const itemsBtn = container.querySelector('.charm-footer button span.items');
    const counterBtn = container.querySelector('.charm-footer button span.counter');
    const popover = container.querySelector('.popover');
    const translations = {
        currencySign: totalQuantity.dataset.currencySign,
        btn_empty: charmBtn.dataset.initialLabel,
        btn_label: charmBtn.dataset.label,
        singleitem: 'ITEM',
        multipleItems: 'ITEMS'
    }

      // ✅ Toggle body class when popover opens/closes
    if (popover) {
        popover.addEventListener('toggle', () => {
            if (popover.matches(':popover-open')) {
                document.body.classList.add('popover-active');
            } else {
                document.body.classList.remove('popover-active');
            }
        });
    }
    
    // handle checked/unchecked products
    charmProducts.forEach(item => {
        item.addEventListener('change', () =>  {
            if(item.checked) {
                handleProductsChange(item.closest('.charm-product'), "ADD");
            } else {
                handleProductsChange(item.closest('.charm-product'), "REMOVE");
            }
        })
    });

    // handle added products remove btn
    addedProductsContainer.addEventListener('remove:btn', (e) => {
        const elmId = e.target.dataset.btnId;
        const popupElm = Array.from(charmProducts).find(input => input.id === elmId);
        if(popupElm) {
            popupElm.checked = false;
            popupElm.dispatchEvent(new Event('change'));
        }
    })

    // handle add/remove of the products
    function handleProductsChange(elm, action) {
        let selectedItems = Array.from(charmProducts).filter(input => input.checked);
        if(selectedItems.length > 0) {
            selectedItems.length > 1 ? itemsBtn.textContent = translations.multipleItems : itemsBtn.textContent = translations.singleitem;
            productForm.setAttribute('data-custom-formdata', '');
            counterBtn.textContent = selectedItems.length;
            charmBtn.textContent = translations.btn_label;
            addedProductsContainer.classList.remove('hidden');
        } else {
            productForm.removeAttribute('data-custom-formdata');
            counterBtn.textContent = 0;
            charmBtn.textContent = translations.btn_empty;
            addedProductsContainer.classList.add('hidden');
        }

        if(elm && action === 'ADD') {
            const item = elm.cloneNode(true);
            item.querySelector('label').remove();
            item.querySelector('.charm_price').remove();
            addedProductsContainer.appendChild(item);
            updateTotalPrice();
        } else if(elm && action === "REMOVE") {
            const item = Array.from(addedProductsContainer.querySelectorAll('.charm-product')).find(product => product.dataset.variantId === elm.dataset.variantId);
            item?.remove();
            updateTotalPrice();
        } 
    }

    // update total price of selected products
    function updateTotalPrice() {
        let totalPrice = 0.00;
        const products = addedProductsContainer.querySelectorAll('.charm-product');
        products.forEach(item => {
            totalPrice += parseFloat(item.dataset.productPrice);
        })

        if(totalPrice.toFixed(2) > 0) {
            totalQuantity.textContent = `(+${translations.currencySign + totalPrice.toFixed(2)})`;
        } else {
            totalQuantity.textContent = '';
        }
    }


    // handle popover/drawer
    inner.addEventListener('click', () => {
        popover.showPopover();

    });

    popoverClose.forEach(btn => {
        btn.addEventListener('click', () => {
            if(popover.matches(':popover-open')) {
                if(window.innerWidth >=768) {
                    popover.classList.add('is-closing');
                    setTimeout(() => {
                        popover.hidePopover();
                        popover.classList.remove('is-closing');
                    }, 500)
                } else {
                    popover.hidePopover();
                }
            }
        })
    })
}

document.addEventListener('DOMContentLoaded', handleAdditionalItems);